import { SET_GROWTH_FORECAST_STAGE_DCF } from "./mutations";

const initialState = {
  growthForecastStageDCF: null
};

const growthForecastStageDCFReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_GROWTH_FORECAST_STAGE_DCF:
      return { ...state, growthForecastStageDCF: payload }

    default:
      return state;
  }
};

export default growthForecastStageDCFReducer;
